'use strict';
currency.$inject = ['$filter', '$browser', '$parse', '$timeout'];
angular.module('schoolLinqApp').directive('currency', currency);

function currency($filter, $browser, $parse, $timeout) {
	return {
		require: 'ngModel',
		link: function ($scope, $element, $attrs, ngModelCtrl) {
			var listener = function () {
				let negativeNotAllowed = false;
				if ($attrs.currency === 'noNegative') {
					negativeNotAllowed = true;
				}

				let selectionStart = $element[0].selectionStart;
				let selectionEnd = $element[0].selectionEnd;
				var value = $element.val().replace(/[^0-9\.\-]+/g, '');
				if (negativeNotAllowed) {
					value = $element.val().replace(/[^0-9\.]+/g, '');
				}
				$element.val(value);
				// if the last key pressed was the tab key then don't reposition the cursor
				// because doing so causes problems for IE browsers (ie. they won't move the
				// cursor to the next element on the form).
				if ($element[0].lastKeyCode !== 9) {
					// if negativeNotAllowed and the input is - then backup the cursor by one since we just ate the invalid key.
					if (negativeNotAllowed && ($element[0].lastKeyCode === 109 || $element[0].lastKeyCode === 189)) {
						$element[0].selectionStart = selectionStart - 1;
						$element[0].selectionEnd = selectionEnd - 1;
					} else {
						$element[0].selectionStart = selectionStart;
						$element[0].selectionEnd = selectionEnd;
					}
				}
				// make sure the user gets instant feedback that a value is required, if it is.
				let float = parseFloat(value);
				if (!float || float === 0) {
					if ($element.attr('required')) {
						ngModelCtrl.$setValidity('required', false);
						$scope.$apply();
					}
				}
			};

			// This runs when we update the text field
			ngModelCtrl.$parsers.push(function (viewValue) {
				if (!viewValue) return 0;
				let negativeNotAllowed = false;
				if ($attrs.currency === 'noNegative') {
					negativeNotAllowed = true;
				}
				let value = viewValue.replace(/[^0-9\.\-]+/g, '');
				if (negativeNotAllowed) {
					value = viewValue.replace(/[^0-9\.]+/g, '');
				}
				let float = parseFloat(value);
				if (!float || float === 0) {
					if ($element.attr('required')) {
						ngModelCtrl.$setValidity('required', false);
					}
				}
				return value;
			});

			// This runs when the model gets updated on the scope directly and keeps our view in sync
			ngModelCtrl.$render = function () {
				if (!ngModelCtrl.$viewValue || ngModelCtrl.$viewValue === 0) {
					$element.val('0.00');
					if ($element.attr('required')) ngModelCtrl.$setValidity('required', false);
				} else {
					$element.val(parseFloat(ngModelCtrl.$viewValue).toFixed(2));
				}
			};

			$element.bind('change', listener);
			$element.bind('keydown', function (event) {
				var keyCode = event.keyCode;
				this.lastKeyCode = keyCode;
				// If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
				// This lets us support copy and paste too
				if (keyCode === 91 || (15 < keyCode && keyCode < 19) || (37 <= keyCode && keyCode <= 40)) {
					return;
				}
				$browser.defer(listener); // Have to do this or changes don't get picked up properly
			});

			$element.bind('paste cut', function () {
				$browser.defer(listener);
			});

			$element.on('blur', function (event) {
				$timeout(() => {
					var float = parseFloat($element.val());
					if (!float || float === 0) {
						$element.val('0.00');
						if ($element.attr('required')) {
							ngModelCtrl.$setValidity('required', false);
							$scope.$apply();
						}
					} else {
						var model = $parse($element.attr('ng-model'));
						model.assign($scope, float.toFixed(2));
						$scope.$apply();
						$element.val(float.toFixed(2));
					}
				}, 0);
			});
		},
	};
}
